import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, ofActionDispatched, Select, Store } from '@ngxs/store';
import { FetchRootAudienceUsers } from 'app/library/all-users/actions';
import { AllUsersState } from 'app/library/all-users/models/all-users.state';
import { User } from 'app/projects/user/src/lib/models/user';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take, tap } from 'rxjs/operators';

export class RootAudienceUserDataSource implements DataSource<User> {
    @Select(AllUsersState.getFilteredEntities)
    filter$: Observable<User>;
    private _data: User[];

    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    get data() {
        return this._data;
    }

    constructor(private _filteredUser$: Observable<User[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<User[]> {
        return this._filteredUser$.pipe(
            tap((filteredUsers) => {
                if (filteredUsers && filteredUsers.length) {
                }
                this._data = filteredUsers;
            })
        );
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadUsers(audienceId?: string, search?: string, sortBy?: string, sortOrder?: string, pageSize?: number, pageNumber?: number): void {
        this._loadingSubject.next(true);
        this._store.dispatch(
            new FetchRootAudienceUsers({
                audienceId,
                search,
                sortBy,
                sortOrder,
                pageSize,
                pageNumber: pageNumber,
            })
        );

        this._action$
            .pipe(
                ofActionDispatched(FetchRootAudienceUsers),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
